import { Component } from 'vue-property-decorator'
import Vue from '@src/vue'
import WorkoutData from '@src/data/workout-data'
import { CreateElement } from 'vue'
import { WorkoutService } from '@src/service/workout'
import Composition from '@src/components/composition/composition'

@Component({
  computed: {
    selectedWorkouts () {
      let selectedWorkouts = []
      this.$store.state.new_training_plan.trainingDays.forEach((day, index) => {
        if (day.workoutAsArray.length > 0) {
          this.$set(selectedWorkouts, index, day.workoutAsArray[0])
        }
      })
      return selectedWorkouts
    }
  }
})
export class TrainingPlanComposition extends Vue {
  private selectedWorkouts: WorkoutData[]

  render (h: CreateElement) {
    let windowWidth = window.innerWidth

    let workoutExercises: any[] = []
    /* istanbul ignore else: the computed always returns an array */
    if (this.selectedWorkouts) {
      this.selectedWorkouts.forEach(workout => {
        workoutExercises = workoutExercises.concat(workout.workoutExercises)
      })
    }

    const progress = new WorkoutService().buildWorkoutComposition(workoutExercises)

    return <Composition progress={progress}
                        muscleCircleDiameter={windowWidth > 800 ? 80 : 85}
                        movementCircleDiameter={windowWidth > 800 ? 80 : 85}
                        filterCallback={this.filterWorkoutExercisesByTags}
                        title={'PAGE.CONTENT.TRAINING_PLAN.TRAINING_PLAN_COMPOSITION'}
                        straigthMobileProgressBars={true}
                        showAssistant={false}/>
  }

  filterWorkoutExercisesByTags (selectedFilters: Set<string>) {
    this.$store.dispatch('filterWorkoutSelector', { tags: selectedFilters })
  }
}
